import _ from 'lodash'

import React from 'react'
import './styles.css'
import CommitmentItem from '../Commitments/CommitmentItem'
import { Divider } from '@wework/dieter-ui'

export default function Commitment({
  border,
  floorMap,
  commitmentsFetchDelay,
  divider,
  space,
  borderBottom = false,
}: any) {
  if (!space) {
    return null
  }

  const { reservable } = space
  if (!reservable) {
    return null
  }

  const renderReservationRows = () => {
    const reservations = _.get(space, 'reservable.reservations')

    if (!reservations || _.size(reservations) === 0) {
      return null
    }

    return _.orderBy(reservations, ['startedOn'], ['asc']).map(
      (reservation, i) => {
        // const lastRow = i === reservations.length - 1
        return (
          <>
            <div
              key={reservation.uuid}
              style={{
                marginTop: 8,
                position: 'relative',
                padding: '16px',
                borderRadius: '.25rem',
                border: border ? '1px solid #E6E6E6' : 0,
              }}
            >
              <CommitmentItem
                //@ts-ignore
                reservation={reservation}
                commitmentsFetchDelay={commitmentsFetchDelay}
              />
            </div>
            {borderBottom ? <Divider light /> : null}
          </>
        )
      }
    )
  }
  return <>{renderReservationRows()}</>
}
